// src/pages/Terms.tsx

import * as React from "react";

import {
  Link,
} from "react-router-dom";

import {
  PublicFooter,
} from "../components/PublicFooter";

import {
  Seo,
} from "../components/Seo";

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export default function Terms():
React.JSX.Element {
  return (
    <main className="public-site">
      <Seo
        title="Terms | Estatly"
        description="Read Estatly's terms of use."
        canonicalPath="/terms"
      />

      <section className="public-legal">
        <div className="public-container public-legal-inner">
          <Link
            to="/"
            className="public-wordmark"
            aria-label="Estatly home"
          >
            Estatly
          </Link>

          <div className="public-legal-content">
            <p className="public-section-label">
              Terms
            </p>

            <h1>
              Terms of use
            </h1>

            <p>
              These terms govern use of the Estatly website and services.
            </p>

            <p>
              This page is a placeholder for the final Estatly terms and should be replaced with the approved legal text before production launch.
            </p>
          </div>
        </div>
      </section>

      <PublicFooter />
    </main>
  );
}